import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "moment";
import { questionQueryCntVoList } from "@/api/management/QAHelper";
export default {
  name: "statistics",
  data: function data() {
    return {
      shortcutList: [{
        code: 1,
        title: "今日"
      }, {
        code: 2,
        title: "最近7天"
      }, {
        code: 3,
        title: "最近30天"
      }, {
        code: 4,
        title: "最近一年"
      }, {
        code: 5,
        title: "去年"
      }, {
        code: 6,
        title: "前年"
      }],
      activeShortcut: {
        code: 2,
        title: "最近7天"
      },
      shortcutDateRange: [moment().subtract("days", 6).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      dateRange: [],
      activeBreadcrumb: "question-views",
      statisticData: [],
      list: [],
      loading: false
    };
  },
  components: {},
  computed: {},
  watch: {
    activeShortcut: function activeShortcut(val) {
      if (val.code) {
        this.dateRange = [];

        switch (val.code) {
          case 1:
            this.shortcutDateRange = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 2:
            this.shortcutDateRange = [moment().subtract("days", 6).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 3:
            this.shortcutDateRange = [moment().subtract("days", 29).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 4:
            this.shortcutDateRange = [moment().subtract("days", 365).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
            break;

          case 5:
            this.shortcutDateRange = [moment().year(moment().year() - 1).startOf("year").format("YYYY-MM-DD"), moment().year(moment().year() - 1).endOf("year").format("YYYY-MM-DD")];
            break;

          case 6:
            this.shortcutDateRange = [moment().year(moment().year() - 2).startOf("year").format("YYYY-MM-DD"), moment().year(moment().year() - 2).endOf("year").format("YYYY-MM-DD")];
            break;

          default:
            this.shortcutDateRange = [];
            break;
        }

        this.handleDataChange();
      } else {
        this.shortcutDateRange = [];
      }
    },
    dateRange: function dateRange(val) {
      if (!val) {
        this.activeShortcut = {
          code: 2,
          title: "最近7天"
        };
        return;
      }

      if (val.length > 0) {
        this.activeShortcut = {};
      }
    },
    statisticData: function statisticData(val) {
      this.handleList();
    },
    activeBreadcrumb: function activeBreadcrumb(val) {
      this.handleList();
    }
  },
  created: function created() {
    this.initContent();
  },
  methods: {
    handleTopProgress: function handleTopProgress(num) {
      if (this.list.length > 0) {
        return num / this.list[0].queCount * 100;
      }

      return 0;
    },
    handleList: function handleList() {
      var _this = this;

      this.list = (this.statisticData.find(function (item) {
        return item.queAct === _this.activeBreadcrumb;
      }) || {}).questionCnts || [];
    },
    shortcutClick: function shortcutClick(item) {
      this.activeShortcut = item;
    },
    handleDataChange: function handleDataChange() {
      this.initContent();
    },
    initContent: function initContent() {
      var _this2 = this;

      var obj = {
        len: 5
      };

      if (this.shortcutDateRange.length) {
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      } else if (this.dateRange) {
        obj.begin_date = this.dateRange[0];
        obj.end_date = this.dateRange[1];
      }

      this.loading = true;
      questionQueryCntVoList(obj).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this2.statisticData = data.data || [];
        } else {
          _this2.$message.error(data.msg);
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    breadcrumbChange: function breadcrumbChange(type) {
      this.activeBreadcrumb = type;
    }
  }
};